import { type IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { type UseQueryOptions, type UseQueryResult, useQuery } from '@tanstack/react-query';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';
import { getCancellationTokenFromSignal } from '@/packages/utils/getCancellationTokenFromSignal';

import { type QueryError, type QueryKey, getQueryKey } from './internal/config';
import { fetchGetModerationComplainMicrofrontendService } from './internal/fetchService';

type UseGetModerationComplainMicrofrontendQueryOptions<TData> = UseQueryOptions<
  IMicrofrontendManifest,
  QueryError,
  TData,
  QueryKey
>;

export function useGetModerationComplainMicrofrontendQuery<TData = IMicrofrontendManifest>(
  options?: UseGetModerationComplainMicrofrontendQueryOptions<TData>,
): UseQueryResult<TData, QueryError> {
  const applicationContext = useQueryStateAppContext();

  return useQuery<IMicrofrontendManifest, QueryError, TData, QueryKey>({
    queryFn: ({ signal }) =>
      fetchGetModerationComplainMicrofrontendService({
        applicationContext,
        cancellationToken: getCancellationTokenFromSignal(signal),
      }),
    queryKey: getQueryKey(),
    ...options,
  });
}
